<!--  -->
<template>
  <div class="find">
    <multi></multi>
    <div class="content">
      <div class="search">
        <div class="searchinp">
          <el-input
            placeholder="请输入您要搜索的招标内容"
            v-model="search"
            class="input-with-select"
            clearable
            @keyup.enter.native="searchgetList()"
            @change="inpChange"
          >
            <el-button class="btn" slot="append" icon="el-icon-search" @click="searchgetList()"></el-button>
          </el-input>
          <button class="screen" @click="screen">
            <i class="el-icon-s-operation"></i>
            <span>筛选</span>
            <i :class="active ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </button>
        </div>
        <transition name="fade">
          <div class="option" v-show="active">
            <div class="box hy">
              <span class="name" style="margin-top:4px;">行业</span>
              <el-divider direction="vertical"></el-divider>
              <ul>
                <li
                  @click="hangye('全部')"
                  :class="topActive == -1 ? 'tagActive' : ''"
                  style="background:#EFEFEF"
                >全部</li>
                <li
                  style="margin-top:10px;margin-bottom:10px;"
                  :class="topActive == index ? 'tagActive' : ''"
                  v-for="(item, index) in toplist"
                  :key="index"
                  @click="hangye(item, index)"
                >{{ item }}</li>
              </ul>
            </div>
            <div class="box">
              <span class="name">区域选择</span>
              <el-divider direction="vertical"></el-divider>

              <button
                class="allbtn"
                @click="qyall()"
                :class="areaActive == -1 ? 'tagActive' : ''"
              >全部</button>
              <el-checkbox-group
                v-model="checkList"
                style="display:inline-block;"
                v-for="(item, index) in countryList"
                :key="index"
              >
                <span class="group">
                  <el-checkbox :label="item[0]" @change="handleAll(item[0])"></el-checkbox>
                  <el-dropdown :hide-on-click="false">
                    <span class="el-dropdown-link">
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item>
                        <el-checkbox-group
                          v-model="country"
                          @change="select($event, items.othercountry)"
                          v-for="(items, index) in item[1]"
                          :key="index"
                        >
                          <el-checkbox :label="items.chinesecountry">
                            {{
                            items.chinesecountry
                            }}
                          </el-checkbox>
                        </el-checkbox-group>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </span>
              </el-checkbox-group>
              <div class="tagList">
                <el-tag v-for="tag in tags" :key="tag" closable @close="handleClose(tag)">{{ tag }}</el-tag>
              </div>
            </div>
            <div class="box">
              <span class="name">价格区间</span>
              <el-divider direction="vertical"></el-divider>
              <span>
                <button
                  class="allbtn"
                  @click="jgall()"
                  :class="moneyActive == -1 ? 'tagActive' : ''"
                >全部</button>
                <el-input-number
                  size="mini"
                  placeholder="请输入内容"
                  v-model="moneystart"
                  @change="checkmoney"
                  :min="0"
                >
                  <span slot="suffix">万元</span>
                </el-input-number>至
                <el-input-number
                  size="mini"
                  :min="0"
                  :max="2147483647"
                  placeholder="请输入内容"
                  v-model="moneyend"
                  @change="checkmoney"
                >
                  <span slot="suffix">万元</span>
                </el-input-number>
              </span>
              <div style="display:inline-block;" v-show="moneyShow">
                <el-button size="mini" @click="money()" class="cz">确定</el-button>
                <el-button size="mini" type="info" @click="moneyReset()" class="cz">重置</el-button>
              </div>
            </div>
            <div class="box">
              <span class="name">发布时间</span>
              <el-divider direction="vertical"></el-divider>
              <span>
                <button
                  class="allbtn"
                  @click="timeall()"
                  :class="timeActive == -1 ? 'tagActive' : ''"
                >全部</button>
                <button
                  class="daybtn"
                  @click="day7()"
                  :class="timeActive == 0 ? 'tagActive' : ''"
                >最近7天</button>
                <button
                  class="daybtn"
                  @click="day30()"
                  :class="timeActive == 1 ? 'tagActive' : ''"
                >最近30天</button>
                <button
                  class="daybtn"
                  @click="lastYear()"
                  :class="timeActive == 2 ? 'tagActive' : ''"
                >去年</button>
                <el-date-picker
                  size="mini"
                  v-model="time"
                  value-format="yyyy-MM-dd"
                  value="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="changeTime"
                ></el-date-picker>
              </span>
              <!-- <el-button size="mini" type="success">确定</el-button> -->
              <el-button size="mini" type="info" @click="timeReset()" class="cz">重置</el-button>
            </div>
            <!-- <div class="box">
              <span class="name">信息类型</span
              ><el-divider direction="vertical"></el-divider>
              <ul>
                <li
                  @click="xinxi('全部')"
                  :class="endActive == -1 ? 'tagActive' : ''"
                  style="background:#EFEFEF"
                >
                  全部
                </li>
                <li
                  :class="endActive == index ? 'tagActive' : ''"
                  v-for="(item, index) in endlist"
                  :key="index"
                  @click="xinxi(item, index)"
                >
                  {{ item }}
                </li>
              </ul>
            </div>-->
          </div>
        </transition>
        <div class="info">
          <div class="infoTitle">
            <span>最新招标信息</span>
            <el-divider direction="vertical"></el-divider>
            <span>{{lableName}}</span>
          </div>
          <div v-show="!done" class="nothing">
            <img src="../assets/nothing.png" alt />
            <p>没有找到与该关键词匹配的信息</p>
          </div>
          <ul v-show="done" class="infoList" v-loading.fullscreen.lock="fullscreenLoading">
            <li
              v-for="(item, index) in infoList"
              :key="index"
              @mouseenter="mouseEnter(index)"
              @mouseleave="mouseLeave"
              :class="{ shadow: index == isActive }"
            >
              <p class="title1" @click="gotoDetail(item.bidid)" v-html="item.othertitle"></p>
              <p class="title2" @click="gotoDetail(item.bidid)" v-html="item.chinesetitle"></p>
              <p class="info">
                <span v-if="item.didcustomer != null">customer：{{ item.didcustomer }}</span>
                <span v-if="item.reletime != null">发布日期：{{ item.reletime }}</span>
              </p>
              <p class="tagGroup">
                <span
                  class="country"
                  v-if="item.nationalFlag"
                  @click="countrygotoFind(item.countrgions)"
                >
                  {{ item.nationalFlag.chinesecountry
                  }}
                  <img
                    :src="
                      `http://182.61.21.235/images/${item.nationalFlag.nfaddress}`
                    "
                    alt
                  />
                </span>
                <span v-else>暂无地区信息</span>
                <el-tag
                  v-if="item.labelo != null"
                  @click="labelgotoFind(item.labelo)"
                >{{ item.labelo }}</el-tag>
                <el-tag
                  v-if="item.labelt != null"
                  @click="labelgotoFind(item.labelt)"
                >{{ item.labelt }}</el-tag>
                <el-tag
                  v-if="item.lables != null"
                  @click="labelgotoFind(item.lables)"
                >{{ item.lables }}</el-tag>
                <el-tag
                  v-if="item.didbudget != null"
                  type="warning"
                  @click="labelgotoFind(item.didbudget)"
                >{{ item.didbudget }}</el-tag>
                <el-tag
                  v-if="item.didnotice != null"
                  type="danger"
                  @click="labelgotoFind(item.didnotice)"
                >{{ item.didnotice }}</el-tag>
                <span class="kbrq" v-if="item.starttime != '' && item.starttime != null">
                  <i class="el-icon-time"></i>
                  开标日期：{{
                  item.starttime
                  }}
                </span>
                <!-- >0f4d72 -->
              </p>
            </li>
          </ul>
          <div class="pagination" v-show="done">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="currentChange"
              layout="prev, pager, next,jumper"
              :total="total"
              :page-size="20"
              background
              :current-page.sync="form.pages"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <login :visible.sync="dialogFormVisible" @result="result"></login>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import multi from '../components/header.vue'
import login from '../components/login.vue'
import tool from '../tool/tool'
import { API_1, Global } from '@/conf/api'
export default {
  //import引入的组件需要注入到对象中才能使用
  name: 'find',
  components: { multi, login },
  data() {
    //这里存放数据
    return {
      dialogFormVisible: false,
      moneyShow: false, //时间筛选按钮显示
      isActive: null, //鼠标进入列表样式
      total: null, //总条数
      done: true, //是否有数据
      fullscreenLoading: false, //loading
      topActive: '-1', //行业 样式active
      endActive: '-1', //信息 样式active
      moneyActive: '-1', //价格 样式active
      timeActive: '-1', //时间 样式active
      areaActive: '-1', //地域 样式active
      form: {
        lable: '', //行业
        countrgion: '', //区域
        didbudgetbegin: 0, //金额开始
        didbudgetend: 0, //金额结束
        reletimebegin: null, //日期开始
        reletimeend: null, //日期结束
        blbone: null, //信息类型
        pages: 1, //页码
        searcwords: null, //搜索框
      },
      toplist: [], //行业列表
      endlist: [], //信息列表
      infoList: [], //数据列表
      currentPage4: 1,
      search: '',
      active: false,
      moneystart: '', //金额开始
      moneyend: '', //金额结束
      time: '', //筛选起止日期区间
      checkList: [], //区域选择list
      country: [],
      tags: [],
      startTime: '', //时间区间传参
      endTime: '',
      countryList: [],
      isAll: false,
      temp: {}, //国家暂存
      all: [],
      tagTemp: [],
      paichuList: [],
      clientHeight: document.body.clientHeight,
      lableName: '全部行业',
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    $route() {
      this.search = this.$route.query.keyWord //获取传来的参数
      this.form.searcwords = this.$route.query.keyWord
      this.form.pages = 1
      this.getList() //路由变化时就重新执行这个方法 更新传来的参数
    },
  },
  //方法集合
  methods: {
    result(val) {
      location.reload()
      // this.uid = tool.getCookie('user')
      // let token = tool.getCookie('qxchuhai')
    },
    handleSizeChange(val) {
      //前往多少页
      this.form.pages = val
      this.getList()
    },
    searchgetList() {
      //搜索框
      this.form.pages = 1
      this.getList()
    },
    inpChange() {
      //搜索框输入变化
      this.form.searcwords = this.search
    },
    checkmoney(val) {
      if (
        (this.moneystart == '' || this.moneystart == undefined) &&
        (this.moneyend == '' || this.moneyend == undefined)
      ) {
        this.moneyShow = false
      } else {
        this.moneyShow = true
      }
      if (this.moneystart == null || this.moneystart == '') {
        this.moneystart = 0
      } else {
        this.moneyActive = 0
      }
      if (this.moneyend == null || this.moneyend == '') {
        this.moneyend = 0
      } else {
        this.moneyActive = 0
      }
    },
    countrygotoFind(val) {
      //点列表国家筛选
      this.form.countrgion = val
      this.form.pages = 1
      this.getList()
    },
    labelgotoFind(val) {
      //点列表标签筛选
      this.lableName = val
      this.form.lable = val
      let index = this.toplist.indexOf(val)
      this.topActive = index
      this.active = true
      this.form.pages = 1
      this.getList()
    },
    timeall() {
      //时间全部

      this.timeActive = -1
      this.time = null
      this.form.reletimebegin = null
      this.form.reletimeend = null
      this.form.pages = 1
      this.getList()
    },
    jgall() {
      //价格全部
      this.moneyActive = -1
      this.form.didbudgetbegin = 0
      this.form.didbudgetend = 0
      this.form.pages = 1
      this.getList()
    },

    top() {
      //行业
      let params = {}
      this.axios
        .get(API_1 + Global.top, { params: params })
        .then((res) => {
          this.toplist = res.data.top
        })
        .catch((res) => {})
    },
    end() {
      //信息
      let params = {}
      this.axios
        .get(API_1 + Global.end, { params: params })
        .then((res) => {
          this.endlist = res.data.end
        })
        .catch((res) => {})
    },
    brightenKeyword(str, key) {
      //str 原内容
      //key 高亮的内容
      // 正则匹配中文、英文关键字高亮，高亮后的关键字和之前的大小写保持一致
      var key = key //这里定义关键词
      key =
        '(' +
        key.replace(/([\+\.\*\|\?\-\(\[\^\$])/g, '\\$1').replace(/\s+/g, '|') +
        ')' //把匹配关键字中的正则符转义
      var patt = new RegExp(key, 'igm') //传  igm  可避免关键词后面的空格造成文字不匹配问题
      var str2 = str.replace(
        patt,
        "<span style='color:#D32C3D;font-weight: bold;'>$1</span>"
      )
      return str2
    },
    find() {
      //筛选 暂时弃用！
      let params = {
        searcwords: this.search,
      }
      if (
        this.search == '' ||
        this.search == null ||
        this.search == undefined
      ) {
      } else {
        this.fullscreenLoading = true
        this.axios
          .get(API_1 + Global.search, { params: params })
          .then((res) => {
            if (res.data.status == 1) {
              this.done = true
              this.infoList = res.data.data[1]
              //this.total = res.data.data.total
            } else if (res.data.status == 0) {
              this.done = false
            }
            this.fullscreenLoading = false
          })
          .catch((res) => {
            console.log(res)
          })
      }
    },
    gotoDetail(id) {
      //跳转详情页
      const { href } = this.$router.resolve({
        path: `detail`,
        query: { id: id },
      })
      window.open(href, '_blank')
      // this.$router.push({
      //   path: 'detail',
      //   query: { id: id },
      // })
    },
    qyall() {
      //区域全部
      this.tags = []
      this.all = []
      this.checkList = []
      this.areaActive = -1
      this.form.countrgion = ''
      this.form.pages = 1
      this.getList()
    },
    handleAll(val) {
      //全选洲际
      //val 洲际名称

      this.areaActive = 0 //样式变化控制
      let ya = []
      let ou = []
      let fei = []
      let da = []
      let nan = []
      let bei = []
      let all = []
      //   new_arr = arr.filter(
      //   (x) => !to_remove.some((item) => arr.indexOf(x) === item)
      // )

      if (val == '亚洲') {
        let arr3 = []
        // this.all 存所有选中的国家 有可能在全选之前 已经选中了部分这个洲的国家
        //indexOf() 可返回某个指定的字符串是否存在 >-1 即没有
        //othercountry 国家名称英文
        for (var i = 0; i < this.temp[val].length; i++) {
          //把all里没有的亚洲国家插入数组 有的忽略不插
          if (this.all.indexOf(this.temp[val][i].othercountry) > -1) {
            arr3.push(this.temp[val][i].othercountry)
          }
          //arr3 所有亚洲国家
        }
        //插入的国家 跟所选的大洲国家一致 用于取消全选 说明all里没有亚洲国家
        if (arr3.length == this.temp[val].length) {
          //all包含 所选的国家
          this.temp[val].map((val) => {
            ya.push(val.othercountry)
          })
          //filter数组过滤器 把all里曾经选过的亚洲国家剔除
          this.all = this.all.filter((x) => !ya.some((item) => x === item))
        } else {
          //all不包含 所选的国家
          this.temp[val].map((val) => {
            this.all.push(val.othercountry)
          })
        }
      }
      if (val == '欧洲') {
        let arr3 = []
        for (var i = 0; i < this.temp[val].length; i++) {
          if (this.all.indexOf(this.temp[val][i].othercountry) > -1) {
            arr3.push(this.temp[val][i].othercountry)
          }
        }
        if (arr3.length == this.temp[val].length) {
          //包含
          this.temp[val].map((val) => {
            ou.push(val.othercountry)
          })
          this.all = this.all.filter((x) => !ou.some((item) => x === item))
        } else {
          //不包含
          this.temp[val].map((val) => {
            this.all.push(val.othercountry)
          })
        }
      }
      if (val == '非洲') {
        let arr3 = []
        for (var i = 0; i < this.temp[val].length; i++) {
          if (this.all.indexOf(this.temp[val][i].othercountry) > -1) {
            arr3.push(this.temp[val][i].othercountry)
          }
        }
        if (arr3.length == this.temp[val].length) {
          //包含
          this.temp[val].map((val) => {
            fei.push(val.othercountry)
          })
          this.all = this.all.filter((x) => !fei.some((item) => x === item))
        } else {
          //不包含
          this.temp[val].map((val) => {
            this.all.push(val.othercountry)
          })
        }
      }
      if (val == '大洋洲') {
        let arr3 = []
        for (var i = 0; i < this.temp[val].length; i++) {
          if (this.all.indexOf(this.temp[val][i].othercountry) > -1) {
            arr3.push(this.temp[val][i].othercountry)
          }
        }
        if (arr3.length == this.temp[val].length) {
          //包含
          this.temp[val].map((val) => {
            da.push(val.othercountry)
          })
          this.all = this.all.filter((x) => !da.some((item) => x === item))
        } else {
          //不包含
          this.temp[val].map((val) => {
            this.all.push(val.othercountry)
          })
        }
      }
      if (val == '南美洲') {
        let arr3 = []
        for (var i = 0; i < this.temp[val].length; i++) {
          if (this.all.indexOf(this.temp[val][i].othercountry) > -1) {
            arr3.push(this.temp[val][i].othercountry)
          }
        }
        if (arr3.length == this.temp[val].length) {
          //包含
          this.temp[val].map((val) => {
            nan.push(val.othercountry)
          })
          this.all = this.all.filter((x) => !nan.some((item) => x === item))
        } else {
          //不包含
          this.temp[val].map((val) => {
            this.all.push(val.othercountry)
          })
        }
      }
      if (val == '北美洲') {
        let arr3 = []
        for (var i = 0; i < this.temp[val].length; i++) {
          if (this.all.indexOf(this.temp[val][i].othercountry) > -1) {
            arr3.push(this.temp[val][i].othercountry)
          }
        }
        if (arr3.length == this.temp[val].length) {
          //包含
          this.temp[val].map((val) => {
            bei.push(val.othercountry)
          })
          this.all = this.all.filter((x) => !bei.some((item) => x === item))
        } else {
          //不包含
          this.temp[val].map((val) => {
            this.all.push(val.othercountry)
          })
        }
      }
      //this.tags 单选国家的时候存的标签名
      //tagTemp 临时标签 其他地方要用 所以用全局
      //说明 如果在全选的之前 没单选过国家
      if (this.tags.length == 0) {
        this.tagTemp = []
      }
      //此事件有可能是取消全选 所以判断选中的国家是为0
      //form.countrgion 给后端发的国家
      //this.all.length == 0 为取消全选 !=0 为全选
      if (this.all.length != 0) {
        //如果以前没有选中的国家 比如其他洲的国家
        if (this.tags.length == 0) {
          this.form.countrgion = '(' + this.all.join('|') + ')'
        } else {
          //如果以前有选中的国家 比如其他洲的国家
          this.form.countrgion =
            '(' + this.all.join('|') + '|' + this.tagTemp.join('|') + ')'
        }
      } else {
        this.form.countrgion = '(' + this.tagTemp.join('|') + ')'
      }

      //取消全选 样式恢复
      if (this.checkList.length == 0) {
        this.areaActive = -1
      }
      this.form.pages = 1
      this.getList()
    },
    allCountry() {
      //筛选洲际国家列表
      let params = {}
      //Global.country
      this.axios
        .get(API_1 + Global.screenCountry, { params: params })
        .then((res) => {
          this.countryList = Object.entries(res.data.data) //把对象的key值以数组的形式遍历出来,key为各个大洲的名字，全选时候需要使用
          this.temp = res.data.data //用于后面来对比是否包含所选的大洲
        })
        .catch((res) => {
          console.log(res)
        })
    },
    timeReset() {
      //时间重置
      this.time = ['', '']
      this.form.reletimebegin = null
      this.form.reletimeend = null
    },
    changeTime() {
      //时间选择
      this.timeActive = 9
      this.form.reletimebegin = this.time[0]
      this.form.reletimeend = this.time[1]
      this.form.pages = 1
      this.getList()
    },
    moneyReset() {
      //重置金额
      this.moneystart = 0
      this.moneyend = 0
      this.moneyActive = -1
    },
    money() {
      if (this.moneystart == null || this.moneystart == '') {
        this.moneystart = 0
      } else {
        this.moneyActive = 0
      }
      if (this.moneyend == null || this.moneyend == '') {
        this.moneyend = 0
      } else {
        this.moneyActive = 0
      }
      this.form.didbudgetbegin = Number(this.moneystart)
      this.form.didbudgetend = Number(this.moneyend)
      this.form.pages = 1
      this.getList()
    },
    hangye(val, index) {
      //行业筛选
      if (val == '全部') {
        this.form.lable = ''
        this.topActive = -1
        this.lableName = '全部行业'
      } else {
        this.topActive = index
        this.form.lable = val
        this.lableName = val
      }

      this.form.pages = 1
      this.getList()
    },
    xinxi(val, index) {
      //信息类型筛选
      if (val == '全部') {
        this.form.blbone = null
        this.endActive = -1
      } else {
        this.endActive = index
        this.form.blbone = val
      }
      this.getList()
    },
    currentChange(val) {
      this.form.pages = val
      let top = document.documentElement.scrollTop || document.body.scrollTop
      document.body.scrollTop = document.documentElement.scrollTop = 0
      this.getList()
      // if (val > 3) {//未登录时限制分页 新改版取消了 暂时注释的
      //   if (tool.getCookie('user')) {
      //     this.form.pages = val
      //     let top =
      //       document.documentElement.scrollTop || document.body.scrollTop
      //     document.body.scrollTop = document.documentElement.scrollTop = 0
      //     this.getList()
      //   } else {
      //     this.form.pages = 1
      //     this.dialogFormVisible = true
      //   }
      // } else {
      //   this.form.pages = val
      //   let top = document.documentElement.scrollTop || document.body.scrollTop
      //   document.body.scrollTop = document.documentElement.scrollTop = 0
      //   this.getList()
      // }

      // 实现滚动效果
      // const timeTop = setInterval(() => {
      //   document.body.scrollTop = document.documentElement.scrollTop = top -= 50
      //   if (top <= 0) {
      //     clearInterval(timeTop)
      //   }
      // }, 2)
    }, //分页
    getList() {
      //获取列表
      this.fullscreenLoading = true //loading
      let params = this.form
      this.axios
        .post(API_1 + Global.find, params)
        .then((res) => {
          if (res.data.status == 1) {
            this.done = true
            this.infoList = res.data.data[1]
            let txt = res.data.data[2]
            if (txt) {
              this.infoList.map((val) => {
                txt.map((vval) => {
                  val.othertitle = this.brightenKeyword(val.othertitle, vval)
                  val.chinesetitle = this.brightenKeyword(
                    val.chinesetitle,
                    vval
                  )
                })
              })
            }
            this.total = Number(res.data.msg)
          } else if (res.data.status == 0) {
            this.done = false
          }
          this.fullscreenLoading = false
        })
        .catch((res) => {})
    },
    day7() {
      this.timeActive = 0
      this.form.reletimebegin = tool.getDate(-7)
      this.form.reletimeend = tool.getDate(0)
      this.form.pages = 1
      this.getList()
    },
    day30() {
      this.timeActive = 1
      this.form.reletimebegin = tool.getDate(-30)
      this.form.reletimeend = tool.getDate(0)
      this.form.pages = 1
      this.getList()
    },
    lastYear() {
      this.timeActive = 2
      this.form.reletimebegin = tool.getYear('s', -1)
      this.form.reletimeend = tool.getYear('e', -1)
      this.form.pages = 1
      this.getList()
    },
    screen() {
      //打开筛选按钮
      this.active = !this.active
    },
    select(val, name) {
      //val 中文名
      //name 英文名
      this.areaActive = 0
      this.tagTemp.push(name)
      this.tags = this.country
      //this.tags = this.tagTemp
      if (this.form.countrgion == '' || this.form.countrgion == '()') {
        this.form.countrgion = '(' + this.tagTemp.join('|') + ')'
      } else {
        this.form.countrgion = this.form.countrgion.replace(/[()]/g, '')
        let temparr = this.form.countrgion + '|' + name
        this.form.countrgion = '(' + temparr + ')'
      }
      this.form.pages = 1
      this.getList()
    },
    handleClose(tag) {
      //删除地区标签
      let name
      let tempList
      this.paichuList.forEach((item) => {
        if (item.chinesecountry == tag) {
          name = item.othercountry
        }
      })
      tempList = this.form.countrgion.replace(/[()]/g, '')
      tempList = tempList.split('|')

      tempList.forEach((item, i) => {
        if (item == name) {
          tempList.splice(i, 1) // 从下标 i 开始, 删除 1 个元素
        }
      })
      if (tempList.length == 0) {
        this.tags = []
        this.all = []
        this.checkList = []
        this.areaActive = -1
        this.form.countrgion = ''
      } else {
        if (this.form.countrgion == '' || this.form.countrgion == '()') {
          this.form.countrgion = '(' + this.tagTemp.join('|') + ')'
        } else {
          tempList = tempList.join('|')
          this.form.countrgion = '(' + tempList + ')'
        }
      }
      this.tags.splice(this.tags.indexOf(tag), 1)
      this.form.pages = 1
      this.getList()
    },
    mouseEnter(index) {
      this.isActive = index
    },
    mouseLeave() {
      this.isActive = null
    },
    paichu() {
      //用于删除区域查询中英文对应国家
      //筛选洲际国家列表
      let params = {}
      this.axios
        .get(API_1 + Global.paichu, { params: params })
        .then((res) => {
          this.paichuList = res.data.data
        })
        .catch((res) => {
          console.log(res)
        })
    },
    hh() {
      this.height.height = window.innerHeight + 'px'
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (this.$route.query.country != undefined) {
      this.form.countrgion = this.$route.query.country
      // this.active = true
    }
    if (this.$route.query.lable != undefined) {
      this.form.lable = this.$route.query.lable
      this.lableName = this.$route.query.lable
      // this.active = true
    }
    this.search = this.$route.query.keyWord
    if (this.$route.query.keyWord == '') {
      this.active = true
    }
    this.form.searcwords = this.$route.query.keyWord
    // if (this.$route.query.keyWord) {
    //   this.find()
    // } else {
    //   this.active = true
    //   this.getList()
    // }
    this.getList()
    this.allCountry()
    this.top()
    this.end()
    this.paichu()
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
  //@import url(); 引入公共css类
  .confirm {
    background: #0f4d72;
    color: #fff;
    border-radius: 5px;
    border: 1px solid #0f4d72;
  }
  .allbtn {
    margin-right: 20px !important;
    width: 75px;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
    color: #666;
    border-radius: 4px;
  }

  .daybtn {
    border-radius: 4px;
    background: #ececec;
    // padding: 5px 10px;
    text-align: center;
    border: 1px solid #ececec;
    color: #666;
    display: inline-block;
    cursor: pointer;
    width: 75px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    box-sizing: border-box;
    margin-right: 20px;
    &:hover {
      background: rgba(15, 77, 114, 0.1) !important;
      color: #333 !important;
    }
  }
  .shadow {
    box-shadow: #0f72b7 0px 0px 18px;
  }
  // /deep/.el-input__suffix {
  //   top: 5px;
  // }
  .tagActive {
    border-radius: 5px;
    background: rgba(15, 77, 114, 0.1) !important;
    // padding: 5px 10px;
    text-align: center;
    // border: 1px solid #c6e2ff !important;
    color: #333 !important;
    display: inline-block;
    cursor: pointer;
    width: 75px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    box-sizing: border-box;

    // margin: 3px 0;
  }
  .tagList {
    margin-left: 73px;
    margin-top: 10px;
    .el-tag {
      margin-right: 10px;
      background: #e7edf1;
      color: #333;
      border: 0;
      /deep/.el-tag__close {
        color: #333;
        &:hover {
          background: #fff;
        }
      }
    }
  }
  .el-dropdown-menu {
    height: 450px;
    overflow-x: scroll;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.1s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  .find {
    background: url('../assets/listbg.jpg') repeat-y top left;
    background-size: 100% auto;
    .content {
      width: 1200px;
      min-width: 1200px;
      margin: 0 auto;
      padding-top: 20px;
      min-height: 650px;
      /deep/.el-input__inner:focus {
        border-color: #0f4d72;
      }
      /deep/.is-active {
        border-color: #0f4d72;
      }
      /deep/.el-checkbox__inner:hover {
        border-color: #0f4d72;
      }
      .info {
        .infoTitle {
          margin-top: 10px;
          border-radius: 6px;
          background: #fff;
          padding: 15px 40px;
          text-align: left;
          span {
            vertical-align: middle;
          }
        }
        .nothing {
          text-align: center;
          background: #eff4f8;
          margin-top: 10px;
          padding: 20px 0;
          p {
            font-size: 18px;
            margin-top: 10px;
          }
        }
        .pagination {
          margin-top: 10px;
          border-radius: 6px;
          background: #eff4f8;
          padding: 15px 40px;
          text-align: center;
          /deep/li {
            background: #f4f4f4;
            color: #666;
          }
          /deep/.active {
            background: #0f4d72;
            color: #fff;
          }
        }
        /deep/ .infoList {
          width: 1200px;
          min-width: 1200px;
          li {
            margin-top: 10px;
            //height: 170px;
            border-radius: 6px;
            // background: #eff4f8;
            background: #fff;
            padding: 15px 40px;
            text-align: left;
            height: 167px;
            box-sizing: border-box;
            &:hover {
              .title1,
              .title2 {
                color: #0f4d72;
              }
            }
            .title1,
            .title2 {
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              width: 800px;
              font-size: 16px;
              font-weight: bold;
              margin-bottom: 10px;
              color: #666;
              cursor: pointer;
            }
            .title2 {
              font-weight: inherit;
              margin-bottom: 20px;
            }
            .info {
              font-size: 12px;
              color: #999;
              margin-bottom: 20px;
              span {
                margin-right: 50px;
              }
            }
            .tagGroup {
              font-size: 12px;
              .el-tag {
                cursor: pointer;
                margin-left: 20px;
                color: #0f4d72;
                background: rgba(15, 77, 114, 0.1);
                height: 24px;
                font-size: 12px;
                line-height: 21px;
                border: 1px solid transparent;
              }
              .country {
                cursor: pointer;
                img {
                  width: 34px;
                  height: 20px;
                  margin-left: 10px;
                  border: 1px solid #dcdcdc;
                }
              }
              .kbrq {
                font-size: 14px;
                float: right;
                color: #0f4d72;
              }
            }
          }
        }
      }
      .search {
        text-align: left;
        .option {
          background: #fff;
          border-radius: 4px;
          padding: 20px;
          font-size: 14px;
          .hy {
            margin-left: 26px;
          }
          .box {
            margin-bottom: 10px;
            padding-bottom: 10px;
            border-bottom: 1px solid #eee;
            div {
              /deep/.cz {
                background: #0f4d72;
                color: #fff;
                border: 1px solid transparent;
                &:hover {
                  background: #105e8c;
                }
              }
            }
            /deep/.cz {
              background: #0f4d72;
              color: #fff;
              border: 1px solid transparent;
              &:hover {
                background: #105e8c;
              }
            }
            /deep/.el-checkbox-group {
              .group {
                /deep/.is-foucs {
                  border-color: #0f4d72 !important;
                }
                .is-checked {
                  .el-checkbox__label {
                    color: #0f4d72;
                  }
                  .is-checked {
                    .el-checkbox__inner {
                      background-color: #0f4d72;
                      border-color: #0f4d72;
                    }
                  }
                }
              }
            }
            button {
              cursor: pointer;
            }
            ul {
              li {
                &:hover {
                  border-radius: 5px;
                  background: rgba(15, 77, 114, 0.1) !important;
                  text-align: center;
                  color: #333 !important;
                }
              }
            }
            .group {
              margin-right: 20px;
            }
          }
          /deep/ .el-button--mini {
            margin: 0 10px;
          }
          /deep/.el-input-number {
            width: 160px;
            margin: 0 10px;
            &:hover {
              border-color: #0f4d72;
            }
          }
          /deep/.el-input--mini {
            &:hover {
              border-color: #0f4d72;
            }
          }
          .name {
            vertical-align: middle;
            height: 40px;
            display: inline-block;
            line-height: 40px;
            // margin-top: 6px;
          }
          ul {
            display: inline-block;
            vertical-align: top;
            width: 1000px;
            li {
              display: inline-block;
              // margin-left: 20px;
              // margin-bottom: 10px;
              color: #666666;
              cursor: pointer;
              width: 75px;
              height: 30px;
              line-height: 30px;
              text-align: center;
              box-sizing: border-box;
              border: 1px solid transparent;
              margin-right: 20px;
              &:hover {
                color: #333;
              }
              // margin: 3px 0;
            }
          }
        }
        .searchinp {
          margin: 0 0 30px 0;
          .screen {
            margin-left: 20px;
            background: #fff;
            border-radius: 4px;
            width: 115px;
            height: 45px;
            font-size: 16px;
            color: #0f4d72;
            text-align: left;
            cursor: pointer;
            i {
              margin-left: 15px;
            }
            span {
              margin-left: 15px;
            }
          }
          /deep/.el-input {
            width: 740px;
            .el-input__inner {
              height: 60px;
              font-size: 18px;
              width: 740px;
            }
            .el-input__inner:focus {
              border-color: #0f4d72;
            }
            .el-input-group__append {
              padding: 0 24px;
              button {
                &:hover {
                  background: #105e8c;
                }
                i {
                  font-size: 20px;
                }
              }
            }
            .btn {
              width: 45px;
              height: 45px;
              background: #0f4d72;
              color: #fff;
              padding: 8px 10px;
              margin: -8px -18px;
              &:hover {
                background: #198ed4;
              }
              /deep/i {
                font-size: 20px;
              }
            }
          }
        }
      }
    }
  }
</style>
